import ReadArtist from '@/views/app/artist/read-artist.view'
import DefaultGuards from '../../../../guards/default.guards'
import multiguard from 'vue-router-multiguard'

export default [{
  path: 'artist/:id',
  name: 'Artista',
  component: ReadArtist,
  meta: {
    breadcrumb: 'Artista',
    title: 'Artista',
    colorHeader: '#E64858',
    top: 0,
    position: 'fixed',
    hidden: 'block',
    height: 30
  },
  beforeEnter: multiguard([
    DefaultGuards.onQuery('events'),
    DefaultGuards.onQuery('artist'),
    DefaultGuards.onQuery('eventArtist')
  ])
}]



// WEBPACK FOOTER //
// ./src/router/routes/app/artist/read-artist.router.js